import Component from "./component";
import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmDateBox, mmDateBoxOptions } from "@/types";

class DateBox extends Component<mmDateBoxOptions> implements mmDateBox {
    private _dxDateBox!: DevExpress.ui.dxDateBox;

    constructor(element: HTMLElement, options?: mmDateBoxOptions) {
        super(element, options);

const initialValue = this._options.value ?? $.cookie("dateFormat");

        this._dxDateBox = ($(this._element) as any)
            .dxDateBox({
                accessKey: this._options.accessKey,
                activeStateEnabled: this._options.activeStateEnabled,
                disabled: this._options.disabled,
                readOnly: this._options.readOnly,
                elementAttr: {
                    class: generateClassName(
                        "date-box",
                        this._options.color!,
                        this._options.size!,
                        this._options.shape,
                        this._options.className,
                    ),
                    ...(this._options.attributes ?? {}),
                },
                inputAttr: this._options.inputAttr,
                height: this._options.height,
                hint: this._options.hint,
                hoverStateEnabled: this._options.hoverStateEnabled,
                rtlEnabled: this._options.rtlEnabled,
                tabIndex: this._options.tabIndex,
                visible: this._options.visible,
                width: this._options.width,
                displayFormat: this._options.displayFormat ?? this.getGlobalDisplayFormat(),
                value: initialValue,
                min: this._options.min,
                name:this._options.name,

                max: this._options.max,
                valueChangeEvent: this._options.valueChangeEvent,
                isDirty: this._options.isDirty,
                isValid: this._options.isValid,
                validationError: this._options.validationError,
                validationErrors: this._options.validationErrors,
                validationMessageMode: this._options.validationMessageMode,
                validationMessagePosition: this._options.validationMessagePosition,
                validationStatus: "valid",
                placeholder: this._options.placeholder,
                label: this._options.label,
                labelMode: this._options.labelMode,
                stylingMode: this._options.style ?? this._options.stylingMode,
                buttons: this._options.buttons,
                showClearButton: this._options.showClearButton,
                pickerType: this._options.pickerType ?? "calendar",
                type: this._options.type ?? "date",
                acceptCustomValue: this._options.acceptCustomValue ?? true,
                showDropDownButton: this._options.showDropDownButton ?? true,
                interval: this._options.interval ?? 30,
                onChange: this._options.onChange,
                onContentReady: this._options.onContentReady,
                onDisposing: this._options.onDisposing,
                onEnterKey: this._options.onEnterKey,
                onFocusIn: this._options.onFocusIn,
                onFocusOut: this._options.onFocusOut,
                onInitialized: this._options.onInitialized,
                onInput: this._options.onInput,
                onKeyDown: this._options.onKeyDown,
                onKeyUp: this._options.onKeyUp,
                onOptionChanged: this._options.onOptionChanged,
                onPaste: this._options.onPaste,
                onValueChanged: this._options.onValueChanged,
            })
            .dxDateBox("instance");
    }
 

    private getGlobalDisplayFormat(): string {
        const cookie = $.cookie("dateFormat");
        if (!cookie) return "yyyy-MM-dd";

        if (this._options.type === "date") return cookie.split(" ")[0];
        else if (this._options.type === "time") return cookie.substring(11);
        return cookie;
    }


  public get value(): string | number | Date | undefined {
    return this._dxDateBox.option("value");
  }

  public set value(val: string | number | Date | undefined) {
    this._dxDateBox.option("value", val);
  }

  public get readOnly(): boolean {
    const val = this._dxDateBox.option("readOnly");
    return val !== undefined ? val : false;
  }
  public set readOnly(val: boolean) {
    this._dxDateBox.option("readOnly", val);
  }

  public get disabled(): boolean {
    const val = this._dxDateBox.option("disabled");
    return val !== undefined ? val : false;
  }
  public set disabled(val: boolean) {
    this._dxDateBox.option("disabled", val);
  }

  public getDefaults(): Partial<mmDateBoxOptions> {
    return {
      value: undefined,
      readOnly: false,
      disabled: false,
      hoverStateEnabled: true,
      activeStateEnabled: true,
      color: "default",
      size: "md",
      shape: "normal",
      valueChangeEvent: "change",
      rtlEnabled: false,
      visible: true,
      width: "100%",
      type: "date",
      pickerType: "calendar",
      acceptCustomValue: true,
      showDropDownButton: true,
      interval: 30,
    };
  }
}

registerComponent("mmDateBox", DateBox);

export default DateBox;
